export const COLUMN_WIDTHS = {
  poNumber: "12%",
  venue: "14%",
  subvenue: "14%",
  role: "14%",
  startDate: "16%",
  endDate: "16%",
  status: "9%",
  actions: "5%"
};

export const COLUMNS = [
  {
    key: "poNumber",
    label: "PO Number",
    width: COLUMN_WIDTHS.poNumber,
    sortable: true
  },
  { key: "venue", label: "Venue", width: COLUMN_WIDTHS.venue, sortable: true },
  {
    key: "subvenue",
    label: "Sub-venue",
    width: COLUMN_WIDTHS.subvenue,
    sortable: true
  },
  { key: "role", label: "Role", width: COLUMN_WIDTHS.role, sortable: true },
  {
    key: "startDate",
    label: "Start Date",
    width: COLUMN_WIDTHS.startDate,
    sortable: true
  },
  {
    key: "endDate",
    label: "End Date",
    width: COLUMN_WIDTHS.endDate,
    sortable: true
  },
  {
    key: "status",
    label: "Active",
    width: COLUMN_WIDTHS.status,
    sortable: true
  },
  { key: "actions", label: "", width: COLUMN_WIDTHS.actions, sortable: false }
];
